module.exports = __webpack_public_path__ + "resources/img/img_txtlogo_makeit_2x.467b222dca29bca26d3ded1398f04013.png";